import React, { useEffect, useState } from "react";
import "./aboutpage.css";
import Dhealnavbar from "../Navbar/dhealnavbar";
import Footer from "../Footer/Footer";
import cmPhoto from "../assest/cm-bihar.jpg";
import ministerPhoto from "../assest/minsiter-bihar.png";
import { FaChevronRight, FaPhoneAlt } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function AboutPage({ toggleTheme }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [fontSize, setFontSize] = useState(100);

  const increaseFont = () => setFontSize((prev) => Math.min(prev + 10, 150));
  const decreaseFont = () => setFontSize((prev) => Math.max(prev - 10, 70));
  const resetFont = () => setFontSize(100);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page-wrapper" style={{ fontSize: fontSize + "%" }}>
      <Dhealnavbar
        toggleTheme={toggleTheme}
        increaseFont={increaseFont}
        decreaseFont={decreaseFont}
        resetFont={resetFont}
      />

      <main className="about-container">
        <nav className="about-breadcrumb" aria-label="Breadcrumb">
          <button type="button" onClick={() => navigate("/")}>{t("home")}</button>
          <FaChevronRight />
          <span>{t("breadcrumbAbout")}</span>
        </nav>

        <section className="about-hero-grid">
          <div className="about-copy">
            <h1>{t("aboutPage.heading")}</h1>
            <p>{t("aboutPage.intro1")}</p>
            <p>{t("aboutPage.intro2")}</p>
            <p>{t("aboutPage.intro3")}</p>
          </div>

          <div className="about-leaders" aria-label="Government leaders">
            <article className="about-leader-card">
              <img src={cmPhoto} alt="Shri Samrat Choudhary" />
              <h2>Shri Samrat Choudhary</h2>
              <p>Hon. Chief Minister</p>
              <span><FaPhoneAlt /> 0612-2222079</span>
            </article>

            <article className="about-leader-card">
              <img src={ministerPhoto} alt="Shri Vijay Kumar Sinha" />
              <h2>Shri Vijay Kumar Sinha</h2>
              <p>Hon. Minister</p>
              <span><FaPhoneAlt /> 0612-2215330</span>
            </article>
          </div>
        </section>

        <section className="about-info-section">
          <p>{t("aboutPage.information")}</p>

          <h2>{t("aboutPage.visionHeading")}</h2>
          <p>{t("aboutPage.visionParagraph")}</p>
        </section>
      </main>
      <Footer />
    </div>
  );
}
